'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// /var/www/festagent_staging/shared/~/react-dom/index.js
// module id = 26
// module chunks = 0 1 2